import * as React from "react";
import {
    FormControl,
    Grid,
    MenuItem,
    InputLabel,
    Select,
    Checkbox,
    Button
} from "@mui/material";

type Props = {
    AllMapLists: any;
    plotQueryProps: any;
    setPlotQueryProps: React.Dispatch<React.SetStateAction<any>>;
    filterConfigList: any;
    listsDisabled: boolean;
    applyUpdates: any;
}
export default function MapPlotFilterList(props: Props) {
    const { AllMapLists, plotQueryProps, setPlotQueryProps, filterConfigList, listsDisabled, applyUpdates } = props;
    return (
        filterConfigList.map((item, index) => {
            return (
                // eslint-disable-next-line react/jsx-key
                <Grid key={index} item xs={1}>
                    <FormControl variant="filled" sx={{ width: 200, maxWidth: 200 }}>
                        <InputLabel id="demo-simple-select-filled-label">
                            {item.name}
                        </InputLabel>
                        <Select
                            label={item.name}
                            name={item.propID}
                            onChange={(e) => {
                                let result;
                                if (typeof e.target.value === 'object') {
                                    if (plotQueryProps[e.target.name].indexOf(item.defaultValue) < 0) {
                                        // @ts-ignore
                                        if (e.target.value.indexOf(item.defaultValue) >= 0) {
                                            result = [item.defaultValue];
                                        }
                                    } else {
                                        // @ts-ignore                                        
                                        result = e.target.value.filter(i => i !== item.defaultValue);
                                    }
                                }                            
                                setPlotQueryProps({ ...plotQueryProps, [e.target.name]: result ?? e.target.value });
                            }}
                            multiple
                            value={plotQueryProps[item.propID]}
                            variant="filled"
                            defaultValue={item.defaultValue}
                            size="small"
                            disabled={listsDisabled}
                            renderValue={
                                (selected) => {
                                    selected = selected.filter(item => {
                                        return item !== undefined && item !== null;
                                    });
                                    if (selected.length > 1) {
                                        return 'Multiple';
                                    } else {
                                        return selected;
                                    }
                                }
                            }
                        >
                            {updateFilter(AllMapLists, item)?.length > 10 &&
                                <MenuItem style={{ padding: 0, margin: "5px 5px 5px 5px" }}>
                                    <Button variant="contained" style={{ width: "100%" }} onClick={(e) => { e.stopPropagation(); applyUpdates(item.propID, plotQueryProps[item.propID]) }}>Apply</Button>
                                </MenuItem>
                            }
                            <MenuItem key={item.defaultValue} value={item.defaultValue}>
                                <Checkbox checked={plotQueryProps[item.propID].indexOf(item.defaultValue) >= 0} style={{ padding: "0 5px 0 0" }} />{item.defaultValue}
                            </MenuItem>
                            {updateFilter(AllMapLists, item)?.map((option) => (
                                <MenuItem key={option[item.valueKey]} value={option[item.valueKey]}>
                                    <Checkbox checked={plotQueryProps[item.propID].indexOf(option[item.valueKey]) >= 0} style={{ padding: "0 5px 0 0" }} />{option[item.valueName]}
                                </MenuItem>
                            ))}
                            <MenuItem style={{padding: 0, margin: "5px 5px 5px 5px"}}>
                                <Button variant="contained" style={{ width: "100%" }} onClick={(e) => {e.stopPropagation(); applyUpdates(item.propID, plotQueryProps[item.propID])}}>Apply</Button>
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            );
        })
    )
}

function updateFilter(AllMapLists, filterConfigItem) {
    const options = AllMapLists?.[filterConfigItem.listName];
    if (options && filterConfigItem.filters) {
        // Currently only 1 filter supported
        const key = Object.keys(filterConfigItem.filters)[0];
        const values = filterConfigItem.filters[key];
        return options.filter(item => values.includes(item[key]));
    } else {
        return options;
    }   
}
